const formatTagText = (tag: string): string => tag.toLowerCase().replace(/[^0-9a-zA-Z_\-+=()@!?$%#/.~,* ]/g, '');

export default formatTagText;
